// src/component/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
    //   behavior: 'smooth'
    });
  };

  useEffect(() => {
    // Scroll on route changes
    scrollToTop();
  
  }, [location.pathname, location.search]);

  return children;
};

export default ScrollToTop;